import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";
import {stat} from "fs";

export interface IUser {
  id: number;
  name: string;
  login: string;
  email: string;
  roles?: string[];
  timeZone: string;
}

export const initialState = {
  user: {} as IUser
};


const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state: IRootState, action: PayloadAction<IUser>) => {
      state.user = action.payload
    },
    clearUser: (state: IRootState) => {
      state.user = {} as IUser
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
